import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FailedGlyph } from "../glyphs.js";
import { Button } from "./Button.js";
export function ProblemBox({ children, onRetry, retryLabel = "Try again", retryBusy = false, wide = false }) {
    return (_jsxs("div", { "data-problem-box": "", role: "alert", style: {
            display: "flex", flexWrap: "wrap", alignItems: "center", gap: "var(--space-15)",
            padding: "14px var(--space-2)", maxWidth: wide ? undefined : "var(--reading-measure)",
            borderRadius: "var(--radius-panel)",
            boxShadow: "inset 0 0 0 var(--border-failed) var(--problem)",
            color: "var(--ink-1)", fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
        }, children: [_jsx(FailedGlyph, {}), _jsx("p", { style: { flex: "1 1 8em", minWidth: 0, margin: 0 }, children: children }), onRetry && (_jsx(Button, { size: "sm", variant: "secondary", onClick: onRetry, disabled: retryBusy, "aria-busy": retryBusy || undefined, children: retryBusy ? "Trying…" : retryLabel }))] }));
}
